import { ArticleBatchDto } from '../../../../shared/dto/article-batch.dto';
import { AfterViewInit, Component, ElementRef, EventEmitter, Signal, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalService, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { ArticleDto } from 'src/app/shared/dto/article.dto';
import { FinalProductDto } from 'src/app/shared/dto/final-product.dto';
import { PackagingDto } from '../../../../shared/dto/packaging.dto';
import { RawMaterialDto } from '../../../../shared/dto/rawMaterial.dto';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { ModalSearchArticlesComponent } from '../modal-search-articles/modal-search-articles.component';
import { MODAL_HEIGHT_LEVEL_2, MODAL_TOP_LEVEL_2, MODAL_WIDTH_LEVEL_2 } from 'src/app/core/constants/components';
import { ProductionOrderProcessesService } from 'src/app/private/services/production-order-processes.service';
import { ArticleSearchResponseDto } from 'src/app/shared/dto/pagination/articles-search-response.dto';
import _ from 'lodash';
import { CommonModule } from '@angular/common';
import { ConfigurationDto } from 'src/app/shared/dto/configuration.dto';
import { ConfigurationTypesEnum } from 'src/app/shared/enums/configuration-types.enum';
import { ConfigurationService } from 'src/app/private/services/configuration.service';
import { ConfigurationKeysEnum } from 'src/app/shared/enums/configuration-keys.enum';
import { NzRowDirective } from 'ng-zorro-antd/grid';
import { showDialog } from 'src/app/shared/utils/utils';
import { LongPressBtnComponent } from 'src/app/shared/components/long-press-btn/long-press-btn.component';
import { ModalSelectRawMaterialActionComponent } from '../modal-select-raw-material-action-component/modal-select-raw-material-action-component';
import { RawMaterialActionsEnum } from 'src/app/shared/enums/raw-material-actions.enum';
import { ModalScanRawMaterialComponent } from '../modal-scan-raw-material/modal-scan-raw-material.component';
import { ProductionOrderProcessDto } from 'src/app/shared/dto/production-order-process.dto';
import { ModalSelectAlternativeArticleComponent } from '../modal-select-alternative-article/modal-select-alternative-article.component';
import { ArticlesService } from 'src/app/private/services/articles.service';
import { RawMaterialToUseDto } from 'src/app/shared/dto/raw-material-to-use.dto';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { PackagingsService } from 'src/app/private/services/packagings.service';
import { StatusEnum } from 'src/app/shared/enums/production-order-state-ids.enum';

interface PlainRawMaterial {
    rawMaterialToUseId?: number;
    description?: string;
    article?: ArticleDto;
    articleBatch?: ArticleBatchDto;
    packaging?: PackagingDto;
    measurementUnit?: string;
    quantity: number;
    isLoadedOnMachine: boolean;
    articleFamily?: string;
    articleFaimilyId?: number;
}

@Component({
    selector: 'app-modal-raw-materials-to-use',
    templateUrl: './modal-raw-materials-to-use.component.html',
    styleUrls: ['./modal-raw-materials-to-use.component.scss'],
    standalone: true,
    imports: [
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzModalTitleDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        ReactiveFormsModule,
        FormsModule,
        NzModalFooterDirective,
        NzMessageModule,
        NzSelectModule,
        NzIconModule,
        NzToolTipModule,
        NzEmptyModule,
        LoaderComponent,
        NzButtonModule,
        CommonModule,
        NzRowDirective,
        LongPressBtnComponent
    ],
})
export class ModalRawMaterialsToUseComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() emitService = new EventEmitter();
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;

    isLoading: boolean = true;
    isSaving: boolean = false;

    productionProcessId: number;
    rawMaterialsUsed: RawMaterialDto[] = [];
    rawMaterialsToUse: RawMaterialToUseDto[] = [];
    plainRawMaterials: PlainRawMaterial[] = [];
    finalProducts: FinalProductDto[] = [];
    tableHeight!: number;
    useSensors: boolean = false;
    useAssess: boolean = false;
    changeArticleEnabled: boolean = false;
    orderProcess!: ProductionOrderProcessDto;
    private readonly consumedQuantitiesSignal?: Signal<Map<number, number>>;

    readonly data? = inject(NZ_MODAL_DATA);

    private readonly unsubscribe$ = new Subject();

    private sensorConfigKey: string = 'productionOrdersProcessesDetail.sensors';

    private readonly modalService = inject(NzModalService);
    private readonly productionOrderProcessesService = inject(ProductionOrderProcessesService);
    private readonly modalRef = inject(NzModalRef);
    private readonly message = inject(NzMessageService);
    private readonly configurationService = inject(ConfigurationService);
    private readonly articlesService = inject(ArticlesService);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly packagingsService = inject(PackagingsService);

    constructor() {
        this.productionProcessId = this.data?.productionProcessId;
        this.orderProcess = this.data?.orderProcess;
        this.finalProducts = this.data?.finalProducts;
        this.rawMaterialsUsed = this.data?.rawMaterialsUsed ?? [];
        this.rawMaterialsToUse = this.data?.rawMaterialsToUse ?? [];
        this.consumedQuantitiesSignal = this.data?.consumedQuantitiesSignal;
    }

    async ngOnInit() {
        const useSensorConfig: ConfigurationDto = await this.configurationService.getConfigurationByKey(this.sensorConfigKey);
        if (useSensorConfig.type === ConfigurationTypesEnum.BOOLEAN && JSON.parse(useSensorConfig.value as string)) {
            this.useSensors = true;
        }

        const changeArticleConfig: ConfigurationDto = await this.configurationService.getConfigurationByKey(ConfigurationKeysEnum.RAW_MATERIALS_CHANGE_ARTICLE_ENABLED);
        if (changeArticleConfig?.type === ConfigurationTypesEnum.BOOLEAN) {
            this.changeArticleEnabled = JSON.parse(changeArticleConfig.value as string);
        }

        if (this.orderProcess.assess) {
            this.useAssess = true;
        }

        this.loadPlainRawMaterials();
        this.loadRawMaterialsUsed();
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next({});
        this.unsubscribe$.complete();
    }

    openSearchArticlesModal() {
        const modal = this.modalService.create({
            nzContent: ModalSearchArticlesComponent,
            nzStyle: { width: MODAL_WIDTH_LEVEL_2, top: MODAL_TOP_LEVEL_2 },
            nzBodyStyle: { height: MODAL_HEIGHT_LEVEL_2 },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Buscar materias primas`,
                articlesToRemove: this.plainRawMaterials.flatMap(plainRawMaterial => {
                    const articleSearchResponseDto = new ArticleSearchResponseDto();
                    articleSearchResponseDto.articleId = plainRawMaterial.article?.id!;
                    articleSearchResponseDto.articleBatchId = plainRawMaterial.articleBatch?.id ?? undefined;
                    articleSearchResponseDto.packagingId = plainRawMaterial.packaging?.id ?? undefined;
                    return articleSearchResponseDto;
                })
            }
        });

        modal.componentInstance?.emitService.subscribe(async (rawMaterialSelected: ArticleSearchResponseDto) => {
            const newRawMaterial = {
                articleId: rawMaterialSelected.articleId ?? undefined,
                articleBatchId: rawMaterialSelected.articleBatchId ?? undefined,
                usedPackagingId: rawMaterialSelected.packagingId ?? undefined
            } as RawMaterialDto;

            if (this.useAssess && this.useSensors && await showDialog(this.modalService, '¿Deseas cargar esta materia prima en la máquina?')) {
                newRawMaterial.isLoadedOnMachine = true;
                const otherRawMaterialLoadedOnMachine = this.plainRawMaterials.find(plainRawMaterial => rawMaterialSelected.articleId === plainRawMaterial.article?.id && plainRawMaterial.isLoadedOnMachine);

                if (otherRawMaterialLoadedOnMachine) {
                    this.rawMaterialsUsed.find(rawMaterial => rawMaterial.id === otherRawMaterialLoadedOnMachine.rawMaterialToUseId)!.isLoadedOnMachine = false;
                }
            }

            this.rawMaterialsUsed = _.cloneDeep((await this.productionOrderProcessesService.updateRawMaterialsUsed(this.orderProcess.id!, [...this.rawMaterialsUsed, newRawMaterial])).rawMaterialsUsed);
            this.loadPlainRawMaterials();
            modal.close();
        });
    }

    async changeArticle(articleToChange: ArticleDto, previousRawMaterial: PlainRawMaterial): Promise<void> {
        if (!articleToChange) {
            this.message.error('No se puede cambiar el artículo: artículo no definido');
            return;
        }

        if (!this.plainRawMaterials) {
            this.message.error('No se puede cambiar el artículo: materias primas no definidas');
            return;
        }

        if (this.orderProcess.status?.id === StatusEnum.FINISHED || this.orderProcess.status?.id === StatusEnum.IN_PROGRESS) {
            this.message.warning('No se puede cambiar el artículo: el proceso está en estado "En curso" o "Finalizado"');
            return;
        }

        let alternativeArticles = this.orderProcess.assess?.articlesAlternatives || [];

        if (alternativeArticles.length === 0 || !articleToChange.useSensors) {
            alternativeArticles = await this.articlesService.findAlternativeArticles(articleToChange.id);
        }

        if (alternativeArticles.length === 0) {
            this.message.warning('No hay artículos alternativos disponibles en el escandallo');
            return;
        }

        const modal = this.modalService.create({
            nzTitle: 'Seleccionar artículo alternativo',
            nzContent: ModalSelectAlternativeArticleComponent,
            nzFooter: null,
            nzClosable: false,
            nzKeyboard: false,
            nzWidth: '600px',
            nzData: {
                alternativeArticles: alternativeArticles,
                currentArticle: articleToChange
            }
        });

        modal.afterClose.subscribe(async (alternativeArticleSelected: ArticleDto | null) => {
            if (alternativeArticleSelected) {
                await this.performArticleChange(articleToChange, alternativeArticleSelected, previousRawMaterial);
            }
        });
    }

    private async performArticleChange(oldArticle: ArticleDto, newArticle: ArticleDto, previousRawMaterial: PlainRawMaterial): Promise<void> {
        try {
            await this.doArticleChange(oldArticle.id, newArticle, previousRawMaterial.rawMaterialToUseId!);
            await this.openScanRawMaterialModal(
                this.plainRawMaterials.find(plainRM => plainRM.rawMaterialToUseId === previousRawMaterial.rawMaterialToUseId)!,
                previousRawMaterial
            );
            this.message.success(`Artículo cambiado de "${oldArticle.name}" a "${newArticle.name}"`);
        } catch (error: any) {
            this.message.error(`Error al cambiar artículo: ${error.message}`);
        }
    }

    /**
     * Lógica común para cambiar el artículo de una materia prima a utilizar.
     * Actualiza en memoria, persiste en la API, y recarga las listas.
     */
    private async doArticleChange(oldArticleId: number, newArticle: ArticleDto, rawMaterialToUseId: number): Promise<void> {
        this.rawMaterialsToUse = this.rawMaterialsToUse.map(rawMaterial => {
            if (rawMaterial.article?.id === oldArticleId && rawMaterial.id === rawMaterialToUseId) {
                rawMaterial.article = newArticle;
                rawMaterial.articleId = newArticle.id;
            }
            return rawMaterial;
        });
        await this.productionOrderProcessesService.updateRawMaterialsToUse(this.orderProcess.id!, this.rawMaterialsToUse);
        this.loadPlainRawMaterials();
        this.loadRawMaterialsUsed();
    }

    /**
     * Cambia el artículo de una materia prima y asigna el lote escaneado automáticamente.
     * Se invoca cuando el escaneo detecta que el lote pertenece a un artículo diferente
     * y el usuario confirma el cambio.
     */
    private async performArticleChangeAndAssignBatch(
        actualRawMaterial: PlainRawMaterial,
        newArticle: ArticleDto,
        articleBatch: ArticleBatchDto
    ): Promise<void> {
        try {
            const oldArticleId = actualRawMaterial.article?.id;
            if (!oldArticleId) {
                this.message.error('No se puede cambiar el artículo: artículo actual no definido');
                return;
            }

            const toastId = this.message.info('Cambiando artículo...', { nzDuration: 0 }).messageId;

            await this.doArticleChange(oldArticleId, newArticle, actualRawMaterial.rawMaterialToUseId!);

            this.message.remove(toastId);

            // Buscar el plainRawMaterial actualizado tras el cambio de artículo
            const updatedPlainRawMaterial = this.plainRawMaterials.find(
                plainRM => plainRM.rawMaterialToUseId === actualRawMaterial.rawMaterialToUseId
            );

            if (!updatedPlainRawMaterial) {
                this.message.error('Error: no se encontró la materia prima actualizada');
                return;
            }

            // Asignar el lote directamente como si el usuario lo hubiera escaneado
            await this.handleScannedRawMaterial(articleBatch, updatedPlainRawMaterial);
            this.message.success(`Artículo cambiado a "${newArticle.name}" y lote asignado correctamente`);
        } catch (error: any) {
            this.message.error(`Error al cambiar artículo y asignar lote: ${error.message}`);
        }
    }

    onLongPressed(previousRawMaterialUsed: PlainRawMaterial) {
        if (!this.changeArticleEnabled) {
            this.message.warning('El cambio de artículo está desactivado');
            return;
        }

        const modal = this.modalService.create({
            nzTitle: 'Seleccionar acción para la materia prima',
            nzContent: ModalSelectRawMaterialActionComponent,
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null
        });

        const instance = modal.getContentComponent();
        instance?.originSelected.subscribe(async (origin: RawMaterialActionsEnum) => {
            modal.close();

            if (origin === RawMaterialActionsEnum.CHANGE_ARTICLE) {
                await this.changeArticle(previousRawMaterialUsed.article!, previousRawMaterialUsed);
            } else if (origin === RawMaterialActionsEnum.DELETE) {
                await this.productionOrderProcessesService.deleteUsedRawMaterialById(previousRawMaterialUsed.rawMaterialToUseId!);
            }
        });
    }

    handleCancel() {
        this.modalRef.close();
    }

    async openScanRawMaterialModal(actualRawMaterial: PlainRawMaterial, previousRawMaterial?: PlainRawMaterial) {
        // Verificar si ya existe un registro previo en rawMaterialsUsed con este rawMaterialToUseId
        const hasExistingRawMaterialUsed = this.rawMaterialsUsed.some(
            rm => rm.rawMaterialToUseId === actualRawMaterial.rawMaterialToUseId
        );

        const modal = this.modalService.create({
            nzContent: ModalScanRawMaterialComponent,
            nzTitle: 'Escanear materia prima',
            nzWidth: '600px',
            nzFooter: null,
            nzClosable: false,
            nzKeyboard: false,
            nzMaskClosable: false,
            nzData: {
                actualArticleId: actualRawMaterial.article?.id,
                actualArticleName: actualRawMaterial.article?.name,
                processStatusId: this.orderProcess?.statusId,
                orderProcessId: this.orderProcess?.id,
                userId: this.userLoggedService.userLogged.id,
                availablePackages: this.finalProducts[0]?.packagings || [],
                articleUseSensors: actualRawMaterial.article?.useSensors || false,
                hasExistingRawMaterialUsed: hasExistingRawMaterialUsed,
                changeArticleAllowed: this.changeArticleEnabled
            }
        });

        modal.afterClose.subscribe(async (result: any) => {
            if (result?.changeArticle) {
                await this.performArticleChangeAndAssignBatch(
                    actualRawMaterial,
                    result.newArticle,
                    result.articleBatch
                );
            } else if (result?.openManualSearch) {
                this.openSearchArticlesModal();
            } else if (result?.articleBatch) {
                await this.handleScannedRawMaterial(
                    result.articleBatch,
                    previousRawMaterial || actualRawMaterial,
                    result.selectedPackage,
                    result.isCurrentMaterialConsumed
                );
            } else if (result) {
                await this.handleScannedRawMaterial(result, actualRawMaterial);
            }
        });
    }

    private async handleScannedRawMaterial(
        articleBatch: ArticleBatchDto,
        plainRawMaterial: PlainRawMaterial,
        selectedPackage?: number,
        isCurrentMaterialConsumed?: boolean
    ): Promise<void> {
        try {
            const newPackagingId = articleBatch.packagings?.[0]?.id;

            // Marcar el packaging actual como consumido si el operario lo indicó
            if (isCurrentMaterialConsumed) {
                const currentRawMaterial = this.rawMaterialsUsed.find(
                    rm => rm.rawMaterialToUseId === plainRawMaterial.rawMaterialToUseId &&
                        rm.isLoadedOnMachine
                );

                if (currentRawMaterial?.usedPackaging) {
                    currentRawMaterial.usedPackaging.consumed = true;
                }
            }

            const newRawMaterial = {
                articleId: articleBatch.articleId ?? undefined,
                articleBatch: articleBatch,
                articleBatchId: articleBatch.id ?? undefined,
                usedPackagingId: newPackagingId,
                rawMaterialToUseId: plainRawMaterial.rawMaterialToUseId,
                isLoadedOnMachine: true,
                rawQuantity: 0
            } as RawMaterialDto;

            const finalProductId = this.orderProcess?.finalProducts?.[0]?.id;
            if (!finalProductId) {
                this.message.error('No se encontró el id del primer producto final en el orderProcess');
                return;
            }

            if (this.useAssess && this.useSensors) {
                // Descargar materias primas con el mismo packaging o batchNumber
                this.rawMaterialsUsed.forEach(rawMaterialUsed => {
                    const samePackaging = newPackagingId && rawMaterialUsed.usedPackagingId === newPackagingId;

                    if (rawMaterialUsed.isLoadedOnMachine &&
                        (rawMaterialUsed.rawMaterialToUseId === plainRawMaterial.rawMaterialToUseId ||
                            samePackaging)) {
                        rawMaterialUsed.rawQuantity = this.getConsumedQuantity(rawMaterialUsed.rawMaterialToUseId);
                        rawMaterialUsed.isLoadedOnMachine = false;
                    }
                });
                if (selectedPackage) {
                    await this.packagingsService.fillQuantitiesUpTo(finalProductId, selectedPackage);

                    await this.packagingsService.handleRawMaterialsInPackagingsOnArticleOrOrderEvent(
                        this.orderProcess.id!,
                        this.userLoggedService.userLogged.id,
                        plainRawMaterial.rawMaterialToUseId!,
                        articleBatch.articleId!,
                        articleBatch.packagings?.[0]?.batchNumber ?? articleBatch.batchNumber!,
                        plainRawMaterial.article?.id,
                        plainRawMaterial.packaging?.batchNumber || plainRawMaterial.articleBatch?.batchNumber, // oldArticleBatchNumber - podría pasarse si es necesario
                        selectedPackage
                    );

                    this.message.success('Materia prima y paquete procesados correctamente');
                } else {
                    if (plainRawMaterial.packaging && (plainRawMaterial.packaging.batchNumber || plainRawMaterial.articleBatch?.batchNumber) && !selectedPackage) {
                        this.message.error('No se ha seleccionado ningún paquete para la materia prima escaneada');
                        await this.openScanRawMaterialModal(plainRawMaterial);
                        return;
                    }
                    await this.packagingsService.handleRawMaterialsInPackagingsOnArticleOrOrderEvent(
                        this.orderProcess.id!,
                        this.userLoggedService.userLogged.id,
                        plainRawMaterial.rawMaterialToUseId!,
                        articleBatch.articleId!,
                        articleBatch.packagings?.[0]?.batchNumber ?? articleBatch.batchNumber!,
                    );
                    this.message.success('Materia prima añadida correctamente');
                }
                this.rawMaterialsUsed = _.cloneDeep(
                    (await this.productionOrderProcessesService.updateRawMaterialsUsed(
                        this.orderProcess.id!,
                        [...this.rawMaterialsUsed, newRawMaterial]
                    )).rawMaterialsUsed
                );
                // Actualizar visualmente en plainRawMaterials
                this.plainRawMaterials.forEach(plainRM => {
                    const samePackaging = newPackagingId && plainRM.packaging?.id === newPackagingId;

                    if (plainRM.isLoadedOnMachine &&
                        plainRM.rawMaterialToUseId !== plainRawMaterial.rawMaterialToUseId &&
                        (samePackaging)) {
                        plainRM.articleBatch = undefined;
                        plainRM.packaging = undefined;
                        plainRM.isLoadedOnMachine = false;
                    }
                });
            } else {
                this.rawMaterialsUsed = _.cloneDeep(
                    (await this.productionOrderProcessesService.updateRawMaterialsUsed(
                        this.orderProcess.id!,
                        [...this.rawMaterialsUsed, newRawMaterial]
                    )).rawMaterialsUsed
                );
            }

            this.loadRawMaterialsUsed();


        } catch (error: any) {
            this.message.error(`Error al añadir materia prima: ${error.message}`);
        }
    }

    private loadPlainRawMaterials(): void {
        this.isLoading = true;

        if (!this.rawMaterialsToUse?.length) {
            this.plainRawMaterials = [];
            this.isLoading = false;
            return;
        }

        this.plainRawMaterials = this.rawMaterialsToUse.map((rawMaterialToUse: RawMaterialToUseDto) => {
            const article = rawMaterialToUse.article;

            return {
                rawMaterialToUseId: rawMaterialToUse.id,
                description: rawMaterialToUse.description,
                article: article,
                articleFamily: rawMaterialToUse.articleFamily?.name ?? '',
                articleFaimilyId: rawMaterialToUse.articleFamily?.id,
                measurementUnit: article?.measurementUnit.abbreviation ?? '',
                quantity: rawMaterialToUse.estimatedQuantity ?? 0,
                isLoadedOnMachine: false,

            };
        });

        this.isLoading = false;
    }

    private loadRawMaterialsUsed() {
        if (!this.rawMaterialsUsed?.length) {
            return;
        }

        for (const rawMaterialUsed of this.rawMaterialsUsed) {
            if (rawMaterialUsed.isLoadedOnMachine) {
                const matchingRawMaterial = this.plainRawMaterials.find(plainRawMaterial =>
                    plainRawMaterial.article?.id === rawMaterialUsed.article?.id
                    && plainRawMaterial.rawMaterialToUseId === rawMaterialUsed.rawMaterialToUseId
                )

                if (matchingRawMaterial) {
                    matchingRawMaterial.quantity = rawMaterialUsed?.rawQuantity ?? 0;
                    matchingRawMaterial.isLoadedOnMachine = true;
                    matchingRawMaterial.articleBatch = rawMaterialUsed?.articleBatch;
                    matchingRawMaterial.packaging = rawMaterialUsed?.usedPackaging;
                }
            }
        }
    }

    private getConsumedQuantity(rawMaterialToUseId?: number): number {
        if (!rawMaterialToUseId || !this.consumedQuantitiesSignal) {
            return 0;
        }

        return this.consumedQuantitiesSignal()?.get(rawMaterialToUseId) ?? 0;
    }
}
